import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { PricePlan } from '@utils/types/back-office/price-plans-bo.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

export const useGetPricePlanBo = (pricePlanId: number) => {
  const { t } = useTranslation();

  const fetchPricePlan = async (pricePlanId: number) => {
    const response = await Axios.get<PricePlan>(
      `${GET_URL(pricePlanId.toString()).pricePlanBo}`
    );
    return response.data;
  };

  return useQuery<PricePlan, AxiosError<BaseError>>(
    ['pricePlans', pricePlanId],
    () => fetchPricePlan(pricePlanId),
    {
      enabled: !!pricePlanId,
      onError: (error: AxiosError<BaseError>) => {
        const errorMessage =
          error.response?.data?.error_description ||
          error.response?.data?.detail ||
          error.response?.data?.error ||
          error.response?.data?.message ||
          t('an-error-occurred-while-fetching-the-price-plan');
        toast.error(errorMessage);
      }
    }
  );
};
